module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DAiYCS/tc-custom/9781611532630.jpg?1684255620212",
      "alt": "This image is the cover for the book Next to Last Mistake"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Next to Last Mistake\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Tess Goodwin’s life in rural Iowa is sheltered and uncomplicated. Although she chooses to spend most of her free time playing chess with her best friend Zander, the farm-boy from next door, her skills as a bovine midwife and tractor mechanic ensure that she fits in with the other kids at West Hancock High. But when her veteran father reenlists in the Army, moving her family halfway across the country to North Carolina, Tess is forced out of her comfort zone into a world she knows nothing about.Tess approaches the move as she would a new game of chess, plotting her course through the unfamiliar reality of her new life. While heeding Zander’s long-distance advice for making new friends and strategizing a means to endure her dad’s imminent deployment to the Middle East, she quickly discovers how ill-equipped she is to navigate the societal challenges she encounters and becomes convinced she’ll never fit in with the students at her new school.When Leonetta Jackson is assigned as her mentor, she becomes Tess’s unexpected guide through the winding labyrinth of cultural disparities between them, sparking a tentative friendship and challenging Tess to confront her reluctant nature. As the pieces move across the board of her upended life, will Tess find the acceptance she so desperately desires?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amalie Jahn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Amalie Jahn is a USA TODAY bestselling author of more than 8 young adult novels, includingThe Next To Last Mistake, her latest release (Light Messages Publishing 2019).Amalie is the recipient of the Literary Classics Seal of Approval and the Readers' Favorite Gold Medal for her debut novel, The Clay Lion. She is a contributing blogger with the Huffington Post and Southern Writers Magazine, as well as a TED speaker, human rights advocate, and active promoter of kindness. She lives in the United States with her husband, two children, and three overfed cats.When she's not at the computer coaxing characters into submission, you can find Amalie swimming laps, cycling, or running on the treadmill, probably training for her next triathlon. She hates pairing socks and loves avocados. She is also very happy time travel does not yet exist.")]), _vm._v(" "), _c('a', {
    staticClass: "authorURL body link",
    attrs: {
      "href": "https://www.amaliejahn.com/",
      "target": "_blank"
    }
  }, [_vm._v("\n    \n            About Author\n       ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "authorURL body link",
    attrs: {
      "href": "https://www.goodreads.com/author/show/6995709.Amalie_Jahn?from_search=true",
      "target": "_blank"
    }
  }, [_vm._v("\n    \n            More  About Author\n       ")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Light Messages Publishing\n   ")]), _vm._v(" "), _c('a', {
    staticClass: "publisherURL body link",
    attrs: {
      "href": "https://www.lightmessages.com/",
      "target": "_blank"
    }
  }, [_vm._v("\n\n        About Publisher\n   ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "publisherURL body link",
    attrs: {
      "href": "https://www.lightmessages.com/amalie-jahn",
      "target": "_blank"
    }
  }, [_vm._v("\n\n        More  About Publisher\n   ")]), _vm._v(" "), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0